import anchorme from "anchorme";

export default class Autolink {
  constructor({ element: element }) {
    this.element = element;
  }

  init() {
    let input = this.element.innerHTML;
    this.element.innerHTML = anchorme({
      input: input,
      options: {
        exclude: function(string) {
          if(string.toLowerCase().includes(".sc") || string.toLowerCase().includes(".si")) {
            return true;
          }
        },
        attributes: function(string) {
          const attributes = {};
          if(!string.includes("vidio.")) {
            attributes.target = "_blank";
          }
          return attributes;
        }
      }
    });
  }
}
